import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "floating-assistant__stack"
};
const _hoisted_2 = ["aria-label"];
const _hoisted_3 = {
  class: "floating-assistant__contact-title"
};
const _hoisted_4 = {
  class: "floating-assistant__contact-list"
};
const _hoisted_5 = ["href", "target", "rel", "onClick"];
const _hoisted_6 = {
  key: 0,
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
const _hoisted_7 = {
  key: 1,
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
const _hoisted_8 = {
  key: 2,
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  fill: "currentColor"
};
const _hoisted_9 = {
  class: "floating-assistant__contact-text"
};
const _hoisted_10 = {
  class: "floating-assistant__contact-label"
};
const _hoisted_11 = {
  key: 0,
  class: "floating-assistant__livechat-tip",
  role: "status"
};
const _hoisted_12 = {
  key: 1,
  class: "floating-assistant__livechat-tip is-failed",
  role: "status"
};
const _hoisted_13 = {
  class: "floating-assistant__contact-value"
};
const _hoisted_14 = ["aria-expanded", "aria-label"];
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from 'vue';
import { onClickOutside } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import AppImage from '@/components/common/AppImage.vue';
import { HELP_SOCIAL_LINKS } from '@/config/help-center';
import { getTrialFundAssets } from '@/constants/trial-fund';
import { copyTextToClipboard } from '@/utils/copy-with-hint';
import { trackAnalyticsLog } from '@/utils/analytics-track';
import { trackSupportContactClick } from '@/utils/analytics-support-contact';
import { isTawkOpening, isTawkSessionActive, subscribeTawkOpening } from '@/utils/open-tawk-chat';
import { openConfiguredLiveChat, resolveSupportLiveChat } from '@/utils/support-livechat';
const STORAGE_KEY_PC = 'floating-assistant-position';
const STORAGE_KEY_H5 = 'floating-assistant-position-h5';
const DRAG_THRESHOLD_PX = 6;
/** PC：按住超过该时长即可拖，无需先点开再拖 */
const PC_LONG_PRESS_MS = 180;
const EDGE_OFFSET = 12;
/** Tab/sticky 顶边至少在视口下半，否则视为量测异常（Tawk 全屏/resize） */
const ANCHOR_TOP_MIN_RATIO = 0.45;
const CONTACT_PANEL_ESTIMATE_PX = 220;
export default {
  __name: 'FloatingAssistantFab',
  props: {
    /** H5：布局用 is-mobile；交互同 PC（点 kefu 展开联系方式） */
    mobile: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const {
      t
    } = useI18n();
    const contactOpen = ref(false);
    const tawkOpening = ref(false);
    const tawkFailed = ref(false);
    const tawkKeepOpen = ref(false);
    const tawkPanelFlag = ref(false);
    const hideKefuForLiveChat = computed(() => tawkPanelFlag.value || tawkKeepOpen.value && !tawkOpening.value);
    const rootRef = ref(null);
    const positioned = ref(false);
    const dragging = ref(false);
    const snapSide = ref(defaultSnapSide());
    /** 靠上时弹层在图标下方，图标贴弹层上侧左右顶点 */
    const contactBelow = ref(false);
    const pos = ref({
      x: 0,
      y: 0
    });
    /** 联系弹层预估高度（用于判断上方是否够展开） */
    function isDocRtl() {
      return typeof document !== 'undefined' && document.documentElement.getAttribute('dir') === 'rtl';
    }

    /** 未拖动时：RTL 默认贴物理左侧（= inline-end），LTR 贴右侧 */
    function defaultSnapSide() {
      return isDocRtl() ? 'left' : 'right';
    }
    let unsubscribeTawkOpening = null;
    let tawkOpenObserver = null;
    let stickyObserver = null;
    let hadPmOutcomeSticky = false;
    let viewportRaf = 0;
    let suppressClickUntil = 0;
    let longPressTimer = 0;
    const dragOffset = {
      x: 0,
      y: 0
    };
    const pointerStart = {
      x: 0,
      y: 0
    };
    let activePointerId = null;
    let pointerMoved = false;
    /** 已越过阈值 / 长按，真正进入拖动 */
    let dragArmed = false;
    /** 最近一次合理坐标（用于关 Tawk / resize 后被错误顶到顶部时回退） */
    let lastStablePos = null;
    const kefuSrc = computed(() => getTrialFundAssets().kefu);
    const positionStyle = computed(() => {
      if (!positioned.value) return undefined;
      return {
        left: `${pos.value.x}px`,
        top: `${pos.value.y}px`,
        right: 'auto',
        insetInlineEnd: 'auto',
        bottom: 'auto'
      };
    });
    const contactChannels = computed(() => {
      const online24h = t('assistant.online24h');
      return [{
        key: 'liveChat',
        label: t('helpPage.contact.liveChat.title'),
        value: t('helpPage.contact.liveChat.line'),
        href: '#',
        external: false,
        copyOnClick: false,
        openLiveChat: true
      }, {
        key: 'telegram',
        label: 'Telegram',
        value: online24h,
        href: HELP_SOCIAL_LINKS.telegram.url,
        external: true,
        copyOnClick: false
      }, {
        key: 'email',
        label: 'Email',
        value: HELP_SOCIAL_LINKS.email.address,
        href: HELP_SOCIAL_LINKS.email.url,
        external: false,
        copyOnClick: true
      }];
    });
    onClickOutside(rootRef, () => {
      contactOpen.value = false;
    });
    watch(contactOpen, open => {
      if (!open) return;
      trackAnalyticsLog({
        key: 'support.open',
        label: '打开客服入口',
        value: {
          source: 'fab'
        }
      });
    });
    function storageKey() {
      return props.mobile ? STORAGE_KEY_H5 : STORAGE_KEY_PC;
    }
    function getFabSize() {
      const cluster = rootRef.value?.querySelector('.floating-assistant__kefu-cluster');
      const size = props.mobile ? 46 : 64;
      return {
        width: cluster?.offsetWidth || size,
        height: cluster?.offsetHeight || size
      };
    }
    function readCssLength(varName, fallback) {
      if (typeof document === 'undefined') return fallback;
      const probe = document.createElement('div');
      probe.style.cssText = `position:fixed;visibility:hidden;pointer-events:none;height:var(${varName});`;
      document.documentElement.appendChild(probe);
      const h = probe.offsetHeight;
      probe.remove();
      return h > 0 ? h : fallback;
    }
    function readSafeAreaBottom() {
      if (typeof document === 'undefined') return 0;
      const probe = document.createElement('div');
      probe.style.cssText = 'position:fixed;left:0;bottom:0;width:0;visibility:hidden;pointer-events:none;height:env(safe-area-inset-bottom,0px)';
      document.documentElement.appendChild(probe);
      const h = probe.offsetHeight;
      probe.remove();
      return h > 0 ? h : 0;
    }

    /** H5 灵活拖动：只留安全区边距，不再用整条底栏顶边锁死 maxY */
    function softMobileBottomInset() {
      return Math.max(EDGE_OFFSET, readSafeAreaBottom() + 8);
    }
    function fallbackBottomInset() {
      if (props.mobile) return softMobileBottomInset();
      return Math.max(EDGE_OFFSET, 24);
    }

    /**
     * 由锚点顶边推底部避让（仅用于下注 sticky 等必须抬高的场景）。
     * 锚点不在下半屏或会把 FAB 压死在顶部时回退软避让。
     */
    function resolveBottomFromAnchorTop(anchorTop, gap) {
      const vh = window.innerHeight;
      const {
        height
      } = getFabSize();
      const top = Math.max(EDGE_OFFSET, readCssLength('--app-chrome-top', props.mobile ? 128 : 72));
      if (!(Number.isFinite(anchorTop) && anchorTop > vh * ANCHOR_TOP_MIN_RATIO && anchorTop < vh + 40)) {
        return fallbackBottomInset();
      }
      let bottom = Math.max(EDGE_OFFSET, vh - anchorTop + gap);
      // 至少留出一段可拖区域，避免 maxY 塌成 top
      const maxBottom = Math.max(EDGE_OFFSET, vh - height - top - 48);
      if (bottom > maxBottom) bottom = maxBottom;
      return bottom;
    }

    /** 顶栏避让；H5 底栏改为软边距；有下注 sticky 时仍抬高 */
    function getViewportInsets() {
      const top = Math.max(EDGE_OFFSET, readCssLength('--app-chrome-top', props.mobile ? 128 : 72));
      const sticky = typeof document !== 'undefined' ? document.querySelector('.pm-outcome-sticky') : null;
      if (sticky) {
        const stickyTop = sticky.getBoundingClientRect().top;
        return {
          top,
          bottom: resolveBottomFromAnchorTop(stickyTop, 10)
        };
      }
      if (props.mobile) {
        return {
          top,
          bottom: softMobileBottomInset()
        };
      }
      return {
        top,
        bottom: fallbackBottomInset()
      };
    }
    function resolveSnapSide(clientX) {
      return clientX < window.innerWidth / 2 ? 'left' : 'right';
    }

    /** 按图标当前位置决定弹层锚点：左/右下角，或靠上时的左/右上角 */
    function updateContactAnchor() {
      if (typeof window === 'undefined') return;
      const {
        width,
        height
      } = getFabSize();
      let x = pos.value.x;
      let y = pos.value.y;
      if (positioned.value) {
        /* use pos */
      } else {
        const def = measureCssDefaultPos();
        if (def) {
          x = def.x;
          y = def.y;
        }
      }
      const centerX = x + width / 2;
      snapSide.value = resolveSnapSide(centerX);
      const {
        top
      } = getViewportInsets();
      const spaceAbove = y - top;
      const spaceBelow = window.innerHeight - (y + height);
      // 上方不够放下弹层，或更靠上半屏且下方更宽裕 → 向下展开
      contactBelow.value = spaceAbove < CONTACT_PANEL_ESTIMATE_PX + 16 || y + height / 2 < window.innerHeight * 0.42 && spaceBelow > spaceAbove;
    }
    function rememberStablePos() {
      const {
        top
      } = getViewportInsets();
      if (pos.value.y <= top + 24) return;
      lastStablePos = {
        x: pos.value.x,
        y: pos.value.y,
        side: snapSide.value
      };
    }
    function clampPosition(nextX, nextY, options = {}) {
      const {
        width,
        height
      } = getFabSize();
      const {
        top,
        bottom
      } = getViewportInsets();
      const maxY = Math.max(top, window.innerHeight - height - bottom);
      const y = Math.min(maxY, Math.max(top, nextY));
      let x;
      if (options.snapX && options.side) {
        x = options.side === 'left' ? EDGE_OFFSET : Math.max(EDGE_OFFSET, window.innerWidth - width - EDGE_OFFSET);
      } else {
        const maxX = Math.max(EDGE_OFFSET, window.innerWidth - width - EDGE_OFFSET);
        x = Math.min(maxX, Math.max(EDGE_OFFSET, nextX));
      }
      return {
        x: Math.round(x),
        y: Math.round(y)
      };
    }
    function applyPosition(nextX, nextY, options = {}) {
      pos.value = clampPosition(nextX, nextY, options);
      positioned.value = true;
    }

    /** 用真实 DOM 矩形校正 pos，避免拖动偏移按错误 left/top 起算 */
    function syncPosFromDom() {
      const el = rootRef.value;
      if (!el || typeof window === 'undefined') return;
      const rect = el.getBoundingClientRect();
      if (!(rect.width > 0 && rect.height > 0)) return;
      pos.value = {
        x: Math.round(rect.left),
        y: Math.round(rect.top)
      };
      positioned.value = true;
    }
    function persistPosition() {
      try {
        localStorage.setItem(storageKey(), JSON.stringify({
          x: pos.value.x,
          y: pos.value.y,
          side: snapSide.value
        }));
      } catch {
        /* ignore */
      }
    }
    function readStoredPosition() {
      try {
        const raw = localStorage.getItem(storageKey());
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        const x = Number(parsed?.x);
        const y = Number(parsed?.y);
        if (!Number.isFinite(x) || !Number.isFinite(y)) return null;
        const side = parsed?.side === 'left' ? 'left' : 'right';
        return {
          x,
          y,
          side
        };
      } catch {
        return null;
      }
    }
    function measureCssDefaultPos() {
      const el = rootRef.value;
      if (!el) return null;
      const prevPositioned = positioned.value;
      positioned.value = false;
      void el.offsetWidth;
      const rect = el.getBoundingClientRect();
      positioned.value = prevPositioned;
      if (!(rect.width > 0 && rect.height > 0)) return null;
      return {
        x: rect.left,
        y: rect.top
      };
    }
    function initPosition() {
      if (!rootRef.value || typeof window === 'undefined') return;
      const stored = readStoredPosition();
      if (stored) {
        snapSide.value = stored.side;
        applyPosition(stored.x, stored.y, {
          snapX: true,
          side: stored.side
        });
        // 本地若已是被错误顶到顶部的脏坐标，回退 CSS 默认
        const {
          top
        } = getViewportInsets();
        if (pos.value.y <= top + 2) {
          const def = measureCssDefaultPos();
          if (def && def.y > top + 40) {
            const {
              width
            } = getFabSize();
            snapSide.value = resolveSnapSide(def.x + width / 2);
            applyPosition(def.x, def.y);
          }
        }
        rememberStablePos();
        return;
      }
      // 首屏沿用 CSS 避让坐标（LTR 右侧 / RTL 左侧），避免贴边 snap 造成跳动
      const def = measureCssDefaultPos();
      if (def) {
        const {
          width
        } = getFabSize();
        snapSide.value = resolveSnapSide(def.x + width / 2);
        applyPosition(def.x, def.y);
        rememberStablePos();
        return;
      }
      const {
        width,
        height
      } = getFabSize();
      const {
        bottom
      } = getViewportInsets();
      const side = defaultSnapSide();
      snapSide.value = side;
      const x = side === 'left' ? EDGE_OFFSET : Math.max(EDGE_OFFSET, window.innerWidth - width - EDGE_OFFSET);
      applyPosition(x, window.innerHeight - height - bottom, {
        snapX: true,
        side
      });
      rememberStablePos();
    }
    function bindDragListeners() {
      window.addEventListener('pointermove', onPointerMove);
      window.addEventListener('pointerup', onPointerUp);
      window.addEventListener('pointercancel', onPointerUp);
    }
    function unbindDragListeners() {
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', onPointerUp);
      window.removeEventListener('pointercancel', onPointerUp);
    }
    function clearLongPressTimer() {
      if (!longPressTimer) return;
      clearTimeout(longPressTimer);
      longPressTimer = 0;
    }
    function armDragOffset(clientX, clientY) {
      if (!positioned.value) {
        const def = measureCssDefaultPos();
        if (def) applyPosition(def.x, def.y);else syncPosFromDom();
      } else {
        // 以当前视觉位置为原点，避免 pos 与 DOM 脱节导致「飞很远」
        syncPosFromDom();
      }
      dragOffset.x = clientX - pos.value.x;
      dragOffset.y = clientY - pos.value.y;
    }
    function beginDrag(clientX, clientY) {
      if (dragArmed) return;
      dragArmed = true;
      pointerMoved = true;
      dragging.value = true;
      contactOpen.value = false;
      armDragOffset(Number.isFinite(clientX) ? clientX : pointerStart.x, Number.isFinite(clientY) ? clientY : pointerStart.y);
    }
    function onKefuPointerDown(event) {
      if (event.button !== 0) return;
      // 避免 img 原生拖拽抢手势（表现为要「再按一次」才能拖）
      event.preventDefault();
      clearLongPressTimer();
      dragArmed = false;
      pointerMoved = false;
      dragging.value = false;
      activePointerId = event.pointerId;
      pointerStart.x = event.clientX;
      pointerStart.y = event.clientY;
      armDragOffset(event.clientX, event.clientY);
      try {
        event.currentTarget?.setPointerCapture?.(event.pointerId);
      } catch {
        /* ignore */
      }
      bindDragListeners();

      // PC：长按即可进入拖动；H5 仍以移动超过阈值进入
      if (!props.mobile) {
        longPressTimer = window.setTimeout(() => {
          longPressTimer = 0;
          if (activePointerId == null) return;
          beginDrag(pointerStart.x, pointerStart.y);
        }, PC_LONG_PRESS_MS);
      }
    }
    function onPointerMove(event) {
      if (event.pointerId !== activePointerId) return;
      const dx = Math.abs(event.clientX - pointerStart.x);
      const dy = Math.abs(event.clientY - pointerStart.y);
      if (!dragArmed) {
        if (dx > DRAG_THRESHOLD_PX || dy > DRAG_THRESHOLD_PX) {
          clearLongPressTimer();
          // 用当前触点重算 offset，避免按下后 pos 被 resize 改掉导致漂移
          beginDrag(event.clientX, event.clientY);
        } else {
          return;
        }
      }
      applyPosition(event.clientX - dragOffset.x, event.clientY - dragOffset.y);
    }
    function onPointerUp(event) {
      if (event.pointerId !== activePointerId) return;
      clearLongPressTimer();
      const wasDrag = dragArmed;
      dragging.value = false;
      activePointerId = null;
      pointerMoved = false;
      dragArmed = false;
      unbindDragListeners();
      if (wasDrag) {
        suppressClickUntil = Date.now() + 400;
        snapSide.value = resolveSnapSide(event.clientX);
        applyPosition(pos.value.x, pos.value.y, {
          snapX: true,
          side: snapSide.value
        });
        rememberStablePos();
        persistPosition();
      }
    }
    function onKefuClick(event) {
      if (Date.now() < suppressClickUntil || dragging.value || dragArmed) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      toggleContact();
    }
    function onViewportChange() {
      // 拖动中勿校正，否则 dragOffset 与 pos 错位会飞出屏
      if (!positioned.value || typeof window === 'undefined' || dragging.value || dragArmed) {
        return;
      }
      if (viewportRaf) cancelAnimationFrame(viewportRaf);
      viewportRaf = requestAnimationFrame(() => {
        viewportRaf = 0;
        if (dragging.value || dragArmed) return;
        const beforeY = pos.value.y;
        const beforeX = pos.value.x;
        applyPosition(beforeX, beforeY);
        const {
          top
        } = getViewportInsets();
        // 关 Tawk / 地址栏 resize 后被错误顶到 chrome 下：回退稳定坐标
        if (pos.value.y <= top + 2 && beforeY > top + 80) {
          const fallback = lastStablePos;
          if (fallback && fallback.y > top + 40) {
            snapSide.value = fallback.side || snapSide.value;
            applyPosition(fallback.x, fallback.y, {
              snapX: true,
              side: snapSide.value
            });
          } else {
            const def = measureCssDefaultPos();
            if (def && def.y > top + 40) {
              const {
                width
              } = getFabSize();
              snapSide.value = resolveSnapSide(def.x + width / 2);
              applyPosition(def.x, def.y);
            } else {
              applyPosition(beforeX, beforeY);
            }
          }
        } else if (pos.value.y > top + 40) {
          rememberStablePos();
        }
      });
    }
    async function toggleContact() {
      // 全局会话已开：再点图标置顶客服，与充值选框「在线客服」一致
      if (isTawkSessionActive()) {
        await openConfiguredLiveChat({
          source: 'fab'
        });
        contactOpen.value = false;
        return;
      }
      if (!contactOpen.value) {
        syncPosFromDom();
        updateContactAnchor();
        resolveSupportLiveChat().catch(() => {});
      }
      contactOpen.value = !contactOpen.value;
    }
    async function onContactChannelClick(event, item) {
      event.preventDefault();
      if (item?.openLiveChat) {
        if (isTawkOpening()) return;
        await openConfiguredLiveChat({
          source: 'fab'
        });
        return;
      }
      trackSupportContactClick({
        channel: item?.key,
        source: 'fab'
      });
      if (item?.copyOnClick !== false) {
        const text = String(item?.value ?? '').trim();
        if (text) {
          await copyTextToClipboard(text);
        }
      }
      const href = String(item?.href ?? '').trim();
      if (!href) return;
      if (item.external) {
        window.open(href, '_blank', 'noopener,noreferrer');
      } else {
        window.location.href = href;
      }
      contactOpen.value = false;
    }
    function onKeydown(e) {
      if (e.key === 'Escape') {
        contactOpen.value = false;
      }
    }
    function syncTawkKeepOpen() {
      if (typeof document === 'undefined') {
        tawkKeepOpen.value = false;
        tawkPanelFlag.value = false;
        return;
      }
      try {
        const html = document.documentElement;
        tawkKeepOpen.value = html.getAttribute('data-ds-tawk-open') === '1';
        tawkPanelFlag.value = html.getAttribute('data-ds-tawk-panel') === '1';
      } catch {
        tawkKeepOpen.value = false;
        tawkPanelFlag.value = false;
      }
    }
    watch(hideKefuForLiveChat, hide => {
      if (hide) contactOpen.value = false;
    });
    watch(tawkOpening, (opening, wasOpening) => {
      if (wasOpening && !opening && !tawkFailed.value) {
        contactOpen.value = false;
      }
    });
    watch(() => props.mobile, async () => {
      await nextTick();
      initPosition();
    });
    onMounted(async () => {
      document.addEventListener('keydown', onKeydown);
      unsubscribeTawkOpening = subscribeTawkOpening((v, failed) => {
        tawkFailed.value = Boolean(failed);
        tawkOpening.value = Boolean(v);
        syncTawkKeepOpen();
      });
      syncTawkKeepOpen();
      if (typeof MutationObserver !== 'undefined') {
        tawkOpenObserver = new MutationObserver(() => {
          syncTawkKeepOpen();
        });
        tawkOpenObserver.observe(document.documentElement, {
          attributes: true,
          attributeFilter: ['data-ds-tawk-open', 'data-ds-tawk-panel']
        });
      }
      await nextTick();
      initPosition();
      hadPmOutcomeSticky = Boolean(document.querySelector('.pm-outcome-sticky'));
      window.addEventListener('resize', onViewportChange);
      window.addEventListener('orientationchange', onViewportChange);
      if (typeof MutationObserver !== 'undefined') {
        stickyObserver = new MutationObserver(() => {
          const has = Boolean(document.querySelector('.pm-outcome-sticky'));
          if (has === hadPmOutcomeSticky) return;
          hadPmOutcomeSticky = has;
          onViewportChange();
        });
        stickyObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    });
    onUnmounted(() => {
      document.removeEventListener('keydown', onKeydown);
      window.removeEventListener('resize', onViewportChange);
      window.removeEventListener('orientationchange', onViewportChange);
      if (viewportRaf) cancelAnimationFrame(viewportRaf);
      viewportRaf = 0;
      clearLongPressTimer();
      unbindDragListeners();
      stickyObserver?.disconnect();
      stickyObserver = null;
      tawkOpenObserver?.disconnect();
      tawkOpenObserver = null;
      if (typeof unsubscribeTawkOpening === 'function') unsubscribeTawkOpening();
    });
    return (_ctx, _cache) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        ref_key: "rootRef",
        ref: rootRef,
        class: _normalizeClass(["floating-assistant", {
          'is-mobile': __props.mobile,
          'is-dragging': dragging.value,
          'is-positioned': positioned.value,
          'is-side-left': snapSide.value === 'left',
          'is-panel-below': contactBelow.value
        }]),
        style: _normalizeStyle(positionStyle.value)
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(["floating-assistant__kefu-cluster", {
          'is-contact-open': contactOpen.value
        }])
      }, [_createVNode(_Transition, {
        name: "fab-menu"
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", {
          class: "floating-assistant__contact",
          role: "dialog",
          "aria-label": _ctx.$t('assistant.contactUs')
        }, [_createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('assistant.contactUs')), 1), _createElementVNode("ul", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contactChannels.value, item => {
          return _openBlock(), _createElementBlock("li", {
            key: item.key
          }, [_createElementVNode("a", {
            class: "floating-assistant__contact-row",
            href: item.href,
            target: item.external ? '_blank' : undefined,
            rel: item.external ? 'noopener noreferrer' : undefined,
            onClick: $event => onContactChannelClick($event, item)
          }, [_createElementVNode("span", {
            class: _normalizeClass(["floating-assistant__contact-icon", `floating-assistant__contact-icon--${item.key}`]),
            "aria-hidden": "true"
          }, [item.key === 'email' ? (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[1] || (_cache[1] = [_createElementVNode("rect", {
            x: "3",
            y: "5",
            width: "18",
            height: "14",
            rx: "2"
          }, null, -1), _createElementVNode("path", {
            d: "M3 7l9 7 9-7"
          }, null, -1)]))])) : item.key === 'liveChat' ? (_openBlock(), _createElementBlock("svg", _hoisted_7, [...(_cache[2] || (_cache[2] = [_createElementVNode("path", {
            d: "M21 12a8.5 8.5 0 01-8.5 8.5H7l-4 3V12A8.5 8.5 0 0112 3.5 8.5 8.5 0 0121 12z"
          }, null, -1), _createElementVNode("circle", {
            cx: "9",
            cy: "12",
            r: "1",
            fill: "currentColor",
            stroke: "none"
          }, null, -1), _createElementVNode("circle", {
            cx: "12.5",
            cy: "12",
            r: "1",
            fill: "currentColor",
            stroke: "none"
          }, null, -1), _createElementVNode("circle", {
            cx: "16",
            cy: "12",
            r: "1",
            fill: "currentColor",
            stroke: "none"
          }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_8, [...(_cache[3] || (_cache[3] = [_createElementVNode("path", {
            d: "M11.944 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0a12 12 0 00-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 01.171.325c.016.093.036.458.02.889-.16 1.885-.862 6.28-.862 6.28-.364 1.56-.866 1.847-1.409 1.859-.582.014-1.01-.384-1.566-.753-.874-.58-1.367-.94-2.215-1.508-.981-.66-.346-1.023.215-1.615.147-.155 2.683-2.46 2.732-2.67a.195.195 0 00-.05-.172c-.034-.034-.084-.024-.127-.014-.054.014-1.87 1.19-5.278 3.49-.5.343-.952.51-1.36.5-.448-.01-1.309-.253-1.95-.46-.786-.255-1.41-.39-1.357-.826.028-.227.334-.46.921-.7 3.608-1.57 6.016-2.605 7.223-3.105 3.443-1.428 4.155-1.676 4.623-1.685z"
          }, null, -1)]))]))], 2), _createElementVNode("span", _hoisted_9, [_createElementVNode("span", _hoisted_10, [_createTextVNode(_toDisplayString(item.label) + " ", 1), item.openLiveChat && tawkOpening.value ? (_openBlock(), _createElementBlock("span", _hoisted_11, [_cache[4] || (_cache[4] = _createElementVNode("span", {
            class: "floating-assistant__livechat-spin",
            "aria-hidden": "true"
          }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$t('assistant.liveChatConnecting')), 1)])) : item.openLiveChat && tawkFailed.value ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('assistant.liveChatFailed')), 1)) : _createCommentVNode("", true)]), _createElementVNode("span", _hoisted_13, _toDisplayString(item.value), 1)])], 8, _hoisted_5)]);
        }), 128))])], 8, _hoisted_2), [[_vShow, contactOpen.value]])]),
        _: 1
      }), _createElementVNode("button", {
        type: "button",
        class: "floating-assistant__kefu",
        "data-trial-guide": "kefu",
        "aria-expanded": contactOpen.value,
        "aria-label": _ctx.$t('assistant.kefuAria'),
        onPointerdown: onKefuPointerDown,
        onClick: onKefuClick,
        onDragstart: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
      }, [_createVNode(AppImage, {
        src: kefuSrc.value,
        alt: "",
        class: "floating-assistant__kefu-img",
        eager: "",
        draggable: "false"
      }, null, 8, ["src"])], 40, _hoisted_14)], 2)])], 6)), [[_vShow, !hideKefuForLiveChat.value]]);
    };
  }
};